const actions = {
  async list(context, payload) {
    try {
      const response = await this.$api.call("privilege.list", payload);
      const responseData = response.data;

      if (payload.shouldMutateStore !== false) {
        context.commit("mutationPrivileges", responseData);
      }

      return response;
    } catch (error) {
      context.commit("mutationPrivileges", []);
      throw error;
    }
  },

  async detail(context, payload) {
    try {
      const response = await this.$api.call("privilege.detail", payload);
      const responseData = response.data;

      if (payload.shouldMutateStore !== false) {
        context.commit("mutationPrivilege", responseData);
      }

      return response;
    } catch (error) {
      context.commit("mutationPrivilege", {});
      throw error;
    }
  },

  async listPermissions(context, payload) {
    try {
      const response = await this.$api.call(
        "privilege.listPermissions",
        payload,
      );

      const responseData = response.data;

      context.commit("mutationPermissions", responseData);
      return response;
    } catch (error) {
      context.commit("mutationPermissions", []);
      throw error;
    }
  },

  async create(_context, payload) {
    try {
      const response = await this.$api.call("privilege.create", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async edit(_context, payload) {
    try {
      const response = await this.$api.call("privilege.edit", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async delete(_context, payload) {
    try {
      const response = await this.$api.call("privilege.delete", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async addPermissions(_context, payload) {
    try {
      const response = await this.$api.call(
        "privilege.addPermissions",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async deletePermissions(_context, payload) {
    try {
      const response = await this.$api.call(
        "privilege.deletePermissions",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async deletePermission(_context, payload) {
    try {
      const response = await this.$api.call(
        "privilege.deletePermission",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async editPermissions(_context, payload) {
    try {
      const response = await this.$api.call(
        "privilege.editPermissions",
        payload,
      );
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
